<template>
  <c-row>
    <c-col col>
      <c-card>
        <c-card-header>
          <c-icon name="cil-justify-center" />
          <strong>Bootstrap Breadcrumb</strong>
          <div class="card-header-actions">
            <a
              href="https://coreui.io/vue/docs/components/breadcrumb"
              class="card-header-action"
              rel="noreferrer noopener"
              target="_blank"
            >
              <small class="text-muted">docs</small>
            </a>
          </div>
        </c-card-header>
        <c-card-body>
          <c-breadcrumb :items="items" />
          <c-breadcrumb :items="items2" />
          <c-breadcrumb :items="items3" />
        </c-card-body>
      </c-card>
    </c-col>
  </c-row>
</template>

<script>
export default {
  name: 'Breadcrumbs',
  data() {
    return {
      items: [
        {
          text: 'Admin',
          href: '#',
        },
        {
          text: 'Manage',
          href: '#',
        },
        {
          text: 'Library',
        },
      ],

      items2: [
        {
          text: 'Go to dashboard',
          to: '/dashboard',
        },
        {
          text: 'Go to widgets',
          to: '/Widgets',
        },
        {
          text: 'Go to Google',
          href: 'http://google.com',
        },
        {
          text: 'Current page',
        },
      ],

      items3: [
        {
          text: 'Added',
          to: '#2',
          addClasses: 'font-xl',
        },
        {
          text: 'Custom',
          to: '#3',
          addClasses: 'font-xl',
        },
        {
          text: 'Classes',
          to: '#4',
          addClasses: 'font-xl text-danger',
        },
      ],
    };
  },
};
</script>

<style>
.breadcrumb-item + .font-xl.breadcrumb-item::before {
  color: rgb(140, 195, 38);
  content: '>>';
  padding: 0px 10px;
}
</style>
